import React from 'react';
import TransactionHistory from '@/components/TransactionHistory';
import { Navbar } from '@/components/Navbar';

const History = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="pt-12 pb-6 px-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">History</h1>
            <p className="text-gray-600 text-sm">Your payment activity</p>
          </div>
        </div>
      </header>
      
      <main className="px-6 pb-24">
        <TransactionHistory />
      </main>
      
      <Navbar />
    </div>
  );
};

export default History;
